export default __webpack_public_path__ + "static/media/tesla.fcf1f513.svg";